/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
// import PrivateRoute from './PrivateRoute';
import { Content } from 'antd/lib/layout/layout';
import Routes from '../Global/Routes';
import Header from '../Components/Header';
import {
  DashboardShop, PrivacyPolicy, TermsAndConditions, Cloud, VmsVault,
} from '../Pages';
import '../Assets/less/layout.less';
import MultipleItems from '../Pages/ProjectList/slider';
import SimpleSlider from '../Pages/SimpleSlider/SimpleSlider';
import ServiceList from '../Pages/ServiceList/serviceList';
import Projects from '../Pages/Projects/projectSlider';
import PublicRoute from './PublicRoute';
import { Footer } from '../Components';
import categoryImages from '../Assets/Images/main-bg.jpg';

const routeImages: { [key: string]: string } = {
  [Routes.ourWork]: categoryImages,
  [Routes.projects]: categoryImages,
  [Routes.project]: categoryImages,
  [Routes.ourService]: categoryImages,
};

const Router = () => {
  const location = useLocation();

  const currentImage = routeImages[location.pathname] || '';

  return (
    <Layout className="kud-layout" style={currentImage === '' ? { backgroundImage: `url(${currentImage})` } : { background: `linear-gradient(360deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.3)),url(${currentImage})` }}>
      <Header />
      <Content>
        <Switch>
          {/* <Route path={Routes.notFound} component={NotFound} exact /> */}
          <PublicRoute path={Routes.home} component={DashboardShop} exact />
          <PublicRoute path={Routes.privacy_policy} component={PrivacyPolicy} exact />
          <PublicRoute path={Routes.terms_and_conditions} component={TermsAndConditions} exact />
          <PublicRoute path={Routes.cloud} component={Cloud} exact />
          <PublicRoute path={Routes.vault} component={VmsVault} exact />
          <Route path={Routes.ourWork} component={MultipleItems} exact />
          <Route path={Routes.project} component={SimpleSlider} exact />
          <Route path={Routes.ourService} component={ServiceList} exact />
          <Route path={Routes.projects} component={Projects} exact />
        </Switch>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Router;
